import React, { useContext } from "react";
import PaymentContext from "../../../store/PaymentContext";
import { useRouter } from "next/router";

interface IProps {
    active: boolean,
    color: string,
    currentStep: number
}

const Step2: React.FC<IProps> = ({ active, color, currentStep }) => {
    const router = useRouter();
    const { isMobile } = useContext(PaymentContext)

    let colorActive = '#274FF5';
    let colorUnActive = '#595959'
    return (
        <>
            {
                // style={{ color: `${active ? colorActive : colorUnActive}` }}
                currentStep >= 2 && (
                    <div className="text-lg cart_header-text-action" >
                        Chi tiết thanh toán
                    </div>
                )
            }
            <div
                // onClick={() => {
                //     if (currentStep === 3) {
                //         router.push('/checkout')
                //     }
                //     router.push('/checkout')
                // }} 
                className="flex items-center">
                <svg width={isMobile ? 24 : 32} height={isMobile ? 24 : 32} viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g filter="url(#filter0_i_3960_174669)">
                        <circle cx={22} cy={22} r={22} fill={active ? colorActive : 'white'} />
                    </g>
                    <path opacity="0.4" d="M28.8579 27.4795H23.3275C22.9732 27.4795 22.6855 27.7641 22.6855 28.1147C22.6855 28.4653 22.9732 28.7498 23.3275 28.7498H28.8579C29.2123 28.7498 29.4999 28.4653 29.4999 28.1147C29.4999 27.7641 29.2123 27.4795 28.8579 27.4795Z" fill={active ? 'white' : colorUnActive} />
                    <path d="M26.0615 21.7504L19.7222 28.0141C19.2883 28.4427 18.7002 28.6849 18.0873 28.6849H15.0975C14.9383 28.6849 14.7867 28.6205 14.6669 28.5104C14.5556 28.3927 14.5 28.2428 14.5 28.0776L14.5796 25.0999C14.5882 24.5096 14.8347 23.9507 15.2567 23.5323L21.5634 17.2923C21.6678 17.189 21.8373 17.189 21.9426 17.2923L26.0615 21.3761C26.1668 21.4794 26.1659 21.6471 26.0615 21.7504Z" fill={active ? 'white' : colorUnActive} />
                    <path opacity="0.4" d="M28.2876 19.5184L27.4256 20.3789C27.2964 20.5076 27.0858 20.5085 26.9557 20.3797L22.9353 16.4018C22.806 16.2739 22.8052 16.0665 22.9344 15.9377L23.7869 15.0866C24.5693 14.3066 25.843 14.3041 26.6287 15.0815L28.2825 16.7177C29.0631 17.4901 29.0657 18.7427 28.2876 19.5184Z" fill={active ? 'white' : colorUnActive} />
                    <defs>
                        <filter id="filter0_i_3960_174669" x={0} y={0} width={44} height={48} filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                            <feFlood floodOpacity={0} result="BackgroundImageFix" />
                            <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                            <feOffset dy={4} />
                            <feGaussianBlur stdDeviation={2} />
                            <feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
                            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                            <feBlend mode="normal" in2="shape" result="effect1_innerShadow_3960_174669" />
                        </filter>
                    </defs>
                </svg>
                <div className="border-b-2 border-gray-200 w-12 h-1 cart_header-line-step"></div>
            </div>
        </>
    )
}

export default Step2;
